import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { castOrderModifier } from '../../Order/utils/castOrderModifier';
import { isTransItem } from './isTransItem';

import { InputItem } from '../types';
type ModString = {
	id: number;
	name: string;
	quantity: string;
	isVariableQuantity: boolean;
};

export const mapModifiersFromTransOrOrderItem = (
	inputItem: InputItem
): string => {
	const modStrings: ModString[] = [];
	const recipeStrings: string[] = [];

	let transModifiers: Percomatic.Serialized.TransModifier[];

	if (isTransItem(inputItem)) {
		transModifiers = inputItem.modifiers;
	} else {
		transModifiers = inputItem.modifiers.map(castOrderModifier);
	}

	for (const { modifier } of transModifiers) {
		if (modifier.isVariableQuantity) {
			const found = modStrings.find(({ id }) => id === modifier.id);

			if (!found) {
				modStrings.push({
					id: modifier.id,
					name: modifier.name,
					quantity: String(1),
					isVariableQuantity: true
				});
			} else {
				found.quantity = (parseInt(found.quantity) + 1).toString();
			}
		} else {
			modStrings.push({
				id: modifier.id,
				name: modifier.name,
				quantity: '',
				isVariableQuantity: false
			});
		}
	}

	return recipeStrings
		.concat(
			modStrings.map(({ name, isVariableQuantity, quantity }) =>
				isVariableQuantity ? `${name} x${quantity}` : name
			)
		)
		.join(', ');
};
